import { RadioGroup, Radio } from "@headlessui/react";

interface Option<T extends string> {
  value: T;
  label: string;
}

interface SegmentedControlProps<T extends string> {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  "aria-label": string;
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
}: SegmentedControlProps<T>) {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className="inline-flex rounded border border-slate-200 dark:border-slate-700 p-0.5 gap-0.5 bg-slate-100 dark:bg-slate-800"
    >
      {options.map((opt) => (
        <Radio
          key={opt.value}
          value={opt.value}
          className={[
            "min-h-[44px] min-w-[44px] px-4 py-2 rounded text-sm font-medium",
            "cursor-pointer transition-all duration-200",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
            "data-[checked]:bg-accent data-[checked]:text-white",
            "data-[checked]:shadow-sm",
            "data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed",
            "text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700",
            "data-[checked]:hover:bg-accent",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {opt.label}
        </Radio>
      ))}
    </RadioGroup>
  );
}
